import Vue from 'vue'
import router from './router'
import VGames from './VGames'
import { i18n } from './i18n/i18n'
import EventConstants from './constants/Events'
import './registerServiceWorker'
import { store } from '@/store/store.js'
import { storeVDog } from '@/store/storeVDog.js'

export const eventBus = new Vue({
  methods: {
    setFullScreen: function (data) {
      this.$emit(EventConstants.SET_FULLSCREEN, data)
    },
    setFullScreenVariable: function (data) {
      this.$emit(EventConstants.CHANGE_FULLSCREEN_VARIABLE, data)
    },
    onVideoPositioning: function () {
      this.$emit(EventConstants.VIDEO_POSITIONING)
    },
    onComponentsVisibility: function (data) {
      this.$emit(EventConstants.COMPONENTS_VISIBLE, data)
    },
    checkModal: function () {
      this.$emit(EventConstants.CHECK_IF_MODAL)
    },
    onConfirmModalResetStake: function (data) {
      this.$emit(EventConstants.VSOCCER_RESET_STAKE_CONFIRM, data)
    },
    onConfirmModalClose: function (data) {
      this.$emit(EventConstants.VSOCCER_CONFIRM_MODAL_CLOSE, data)
    },
    onConfirmMatch: function (data) {
      this.$emit(EventConstants.VSOCCER_CONFIRM_ACTIVE_STAKE, data)
    },
    removePickedMatch: function (data) {
      this.$emit(EventConstants.VSOCCER_REMOVE_PICKED_MATCH, data)
    },
    onSelectedStakeVSoccer: function (data) {
      this.$emit(EventConstants.VSOCCER_SELECTED_STAKE, data)
    },
    onChangedPicksLength: function (length) {
      this.$emit(EventConstants.VSOCCER_CHANGE_PICKS_LENGTH, length)
    },
    onNewRound: function () {
      this.$emit(EventConstants.VSOCCER_NEW_ROUND)
    },
    disabledBettingMatch: function (data) {
      this.$emit(EventConstants.VSOCCER_DISABLE_BETTING_MATCH, data)
    },
    toggleSideMenuMobile: function (data) {
      this.$emit(EventConstants.VSOCCER_TOGGLE_ASIDE_MENU_MOBILE, data)
    },
    toggleModalErrorConnection: function (data) {
      this.$emit(EventConstants.VSOCCER_SHOW_CONNECTION_ERROR_MODAL, data)
    },
    secondToStartVSoccer: function (data) {
      this.$emit(EventConstants.VSOCCER_TIMER_TICK_TIMER, data)
    },
    onGetResult: function (data) {
      this.$emit(EventConstants.VSOCCER_GET_RESULT, data)
    },
    onShowMatchResult: function (data) {
      this.$emit(EventConstants.VSOCCER_SHOW_MATCH_RESULT, data)
    },
    onApiError: function (error) {
      this.$emit(EventConstants.VSOCCER_SHOW_API_ERROR, error)
    },
    onMaintenance: function (error) {
      this.$emit(EventConstants.VSOCCER_SHOW_MAINTENANCE, error)
    },
    onTicketInserted: function (data) {
      this.$emit(EventConstants.VSOCCER_TICKET_INSERTED, data)
    },
    onRefreshActiveBets: function (data) {
      this.$emit(EventConstants.VSOCCER_REFRESH_ACTIVE_BETS, data)
    },
    toggleLeftMenu: function (data) {
      this.$emit(EventConstants.VSOCCER_TOGGLE_LEFT_MENU, data)
    },
    showJackpotValue: function (data) {
      this.$emit(EventConstants.VSOCCER_SHOW_JACKPOT_VALUE, data)
    },
    showJackpotValueWithType: function (data) {
      this.$emit(EventConstants.VSOCCER_SHOW_JACKPOT_VALUE_WITH_TYPE, data)
    },
    showNewScore: function (data) {
      this.$emit(EventConstants.VSOCCER_SHOW_NEW_SCORE, data)
    },
    onShowResultsHeader: function (data) {
      this.$emit(EventConstants.VSOCCER_SHOW_RESULTS_HEADER, data)
    },
    updateTotalOdds: function (data) {
      this.$emit(EventConstants.VSOCCER_TOTAL_ODDS, data)
    },
    showBettingHistory: function (data) {
      this.onConfirmModalResetStake()
      this.$emit(EventConstants.VSOCCER_SHOW_BETTING_HISTORY, data)
    },
    onShowTime: function (data) {
      this.$emit(EventConstants.VSOCCER_SHOW_TIMER, data)
    },
    onChangeNumberOfActiveTickets: function (data) {
      this.$emit(EventConstants.VSOCCER_NUMBER_ACTIVE_TICKETS_LENGTH, data)
    },
    onBettingHistoryRefresh: function (data) {
      this.$emit(EventConstants.VSOCCER_BETTING_HISTORY_REFRESH, data)
    },
    onShowFallenJackpots: function (data) {
      this.$emit(EventConstants.VSOCCER_SHOW_FALLEN_JACKPOTS, data)
    },
    customEvent: function (event, data) {
      this.$emit(event, data)
    },
    onSelectedStakeVDog: function (data) {
      this.$emit(EventConstants.VDOG_SELECTED_STAKE, data)
    },
    onGetResultVDog: function (data) {
      this.$emit(EventConstants.VDOG_GET_RESULT, data)
    },
    onNewRoundVDog: function () {
      this.$emit(EventConstants.VDOG_NEW_ROUND)
    },
    onApiErrorVDog: function (error) {
      this.$emit(EventConstants.VDOG_SHOW_API_ERROR, error)
    },
    onTicketInsertedVDog: function (data) {
      this.$emit(EventConstants.VDOG_TICKET_INSERTED, data)
    },
    showJackpotValueVDog: function (data) {
      this.$emit(EventConstants.VDOG_SHOW_JACKPOT_VALUE, data)
    },
    onShowMatchResultVDog: function (data) {
      this.$emit(EventConstants.VDOG_SHOW_MATCH_RESULT, data)
    },
    toggleLeftMenuVDog: function (data) {
      this.$emit(EventConstants.VDOG_TOGGLE_LEFT_MENU, data)
    },
    onMaintenanceVDog: function (error) {
      this.$emit(EventConstants.VDOG_SHOW_MAINTENANCE, error)
    },
    secondToStartVDog: function (data) {
      this.$emit(EventConstants.VDOG_TIMER_TICK_TIMER, data)
    },
    onChangeNumberOfActiveTicketsVDog: function (data) {
      this.$emit(EventConstants.VDOG_NUMBER_ACTIVE_TICKETS_LENGTH, data)
    },
    onRefreshActiveBetsVDog: function (data) {
      this.$emit(EventConstants.VDOG_REFRESH_ACTIVE_BETS, data)
    },
    showBettingHistoryVDog: function (data) {
      this.onResetAndCloseVDog()
      this.$emit(EventConstants.VDOG_SHOW_BETTING_HISTORY, data)
    },
    onChangedPicksLengthVDog: function (data) {
      this.$emit(EventConstants.VDOG_CHANGE_PICKS_LENGTH, data)
    },
    onConfirmModalCloseVDog: function (data) {
      this.$emit(EventConstants.VDOG_CONFIRM_MODAL_CLOSE, data)
    },
    onConfirmVDog: function (data) {
      this.$emit(EventConstants.VDOG_CONFIRM, data)
    },
    onResetAndCloseVDog: function (data) {
      this.$emit(EventConstants.VDOG_RESET_AND_CLOSE, data)
    },
    onResetVDog: function (data) {
      this.$emit(EventConstants.VDOG_RESET, data)
    },
    onShowFallenJackpotsVDog: function (data) {
      this.$emit(EventConstants.VDOG_SHOW_FALLEN_JACKPOTS, data)
    },
    onChangeGameAction: function (data) {
      store.setGameInProgress(false)
      storeVDog.setGameInProgress(false)
      this.$emit(EventConstants.CHANGE_GAME_ACTION, data)
    },
    onGameScrollLock: function (data) {
      this.$emit(EventConstants.LOCKING_SCROLL_GLOBAL)
    },
    onGameScrollUnock: function (data) {
      this.$emit(EventConstants.UNLOCKING_SCROLL_GLOBAL)
    },
    onLoadingComplete: function (data) {
      this.$emit(EventConstants.LOADING_COMPLETE)
    },
    onVsoccerComponentLoaded: function (data) {
      this.$emit(EventConstants.VSOCCER_COMPONENT_LOAD_COMPLETE)
    },
    onVDogComponentLoaded: function (data) {
      this.$emit(EventConstants.VDOG_COMPONENT_LOAD_COMPLETE)
    },
    onVDogBettingHistoryRefresh: function (data) {
      this.$emit(EventConstants.VDOG_BETTING_HISTORY_REFRESH, data)
    },
    onVDogFloatingAction: function (data) {
      this.$emit(EventConstants.VDOG_FLOATING_ACTION, data)
    },
    onFloatingAction: function (data) {
      this.$emit(EventConstants.VSOCCER_FLOATING_ACTION, data)
    }
  }
})

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  render: h => h(VGames)
}).$mount('#virtual-games')
